import React, { useState } from 'react';
import { Lists, AddList, EditList, AddTask } from '../containers';
import {
  useShowListEditOptionContext,
  ShowListEditBoxProvider,
  useAllInOneContext,
  useActiveListContext,
} from '../../context';
import { Core } from '..';
import { ScrollBox, Heading } from './styles';
import { Desktop, Mobile } from '../../media_queries';
import { FillSpace } from '../dnd_list/styles';

export default function ListBox({
  setShowTasks = null,
  addListRef = null,
  addTaskRef = null,
}) {
  const {
    showListEditOption,
    setShowListEditOption,
  } = useShowListEditOptionContext();
  const { lists } = useAllInOneContext();
  const { themeColor } = useActiveListContext();
  const [progress, setProgress] = useState(0);
  const [isInDelete, setIsInDelete] = useState(false);

  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={isInDelete}
      >
        Deleting the list...
      </Core.ForceAlert>

      <div>
        <Core.InlineLayout
          justifyContent='space-between'
          style={{ padding: '0 10px' }}
        >
          <Heading style={{ color: themeColor }}>Lists</Heading>

          {lists && lists.length > 0 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                marginBottom: '1em',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    color: themeColor,
                    marginRight: '5px',
                    marginTop: '2.5px',
                    fontWeight: 'bold',
                    textShadow: '0 4px 6px rgb(0 0 0 / 50%)',
                  }}
                >
                  Edit
                </div>
                <Core.Switch
                  style={{ boxShadow: '0 0 10px 3px rgb(0 0 0 / 25%)' }}
                  color={themeColor}
                  value={showListEditOption}
                  onClick={() => setShowListEditOption(!showListEditOption)}
                ></Core.Switch>
              </div>
            </div>
          )}
        </Core.InlineLayout>
      </div>

      <Desktop>
        <ShowListEditBoxProvider>
          <ScrollBox>
            <Lists
              setShowTasks={setShowTasks}
              setProgress={setProgress}
              isInDelete={isInDelete}
              setIsInDelete={setIsInDelete}
            />
            <FillSpace></FillSpace>
          </ScrollBox>

          <AddList />

          <EditList />
        </ShowListEditBoxProvider>
      </Desktop>

      <Mobile>
        <ScrollBox forMobile={true}>
          <Lists
            forMobile={true}
            setShowTasks={setShowTasks}
            setProgress={setProgress}
            isInDelete={isInDelete}
            setIsInDelete={setIsInDelete}
          />
          <FillSpace></FillSpace>
        </ScrollBox>

        <AddList addListRef={addListRef} />

        <AddTask addTaskRef={addTaskRef} />

        <EditList />
      </Mobile>
    </>
  );
}
